<template>
  <span v-for="letter in writeName" :key="letter.id">{{ letter }}</span>
</template>

<script>
export default {
  props: {
    part: {
      type: String,
      required: true,
    },
  },
  computed: {
    writeName() {
      let name = this.part,
        letters = name.split(""),
        result = "";

      for (let i = 0; i < letters.length; i++) {
        const letter = letters[i];
        result += letter.trim() === "" ? "" : letter;
      }

      return result;
    },
  },
};
</script>